// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"60":"dd0174a2","102":"d0d81eb6","919":"05962d0e"}[chunkId] + ".js";
};